import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEndCustomerPaid } from "Context/EndCustomerPaid";
import { usePopupNotificationContext } from "Context/NotificationPopup";
import { useState } from "react";

const DeleteBundleButton = () => {
  const { deleteBundle, selectedBundle, selectedBundleId } =
    useEndCustomerPaid();
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const { openError, openSuccess } = usePopupNotificationContext();

  const disabled = selectedBundleId == null || loadingDelete;

  const open = () => {
    setIsConfirmed(false);
    setIsOpen(true);
  };

  const close = () => setIsOpen(false);

  const handleDelete = async () => {
    close();
    setLoadingDelete(true);

    const res = await deleteBundle();

    if (res && res.status === 201) {
      openSuccess(res.data.Message ? res.data.Message : "OK", 3000);
    } else {
      const data = res && res.data;
      const message =
        typeof data === "string"
          ? data
          : data && data.Message
          ? data.Message
          : null;
      openError(
        message ? message : "Någonting gick fel när filen skulle tas bort",
        5000
      );
    }

    setLoadingDelete(false);
  };

  return (
    <>
      <Tooltip title="Ta bort inbetalningsfil">
        <span style={{ display: "flex", flexShrink: 0 }}>
          <IconButton
            onClick={open}
            disabled={disabled}
            color="error"
            aria-label="Ta bort inbetalningsfil"
          >
            {loadingDelete ? (
              <CircularProgress size={24} color="error" />
            ) : (
              <DeleteOutlineIcon />
            )}
          </IconButton>
        </span>
      </Tooltip>

      <Dialog open={isOpen} onClose={close} maxWidth="xs" fullWidth>
        <DialogTitle>Ta bort inbetalningsfil</DialogTitle>
        <DialogContent>
          <Typography fontWeight={600} sx={{ marginBottom: "0.75rem" }}>
            {selectedBundle ? selectedBundle.FileName : ""}
          </Typography>

          <Typography variant="body2">Följande kommer att tas bort:</Typography>
          <Typography
            variant="body2"
            component="ul"
            sx={{ marginTop: "0.25rem", paddingLeft: "1.5rem" }}
          >
            <li>Inbetalningsfilen</li>
            <li>Bunten</li>
            <li>Inbetalningar</li>
            <li>Kopplingsförslag</li>
          </Typography>

          <FormControlLabel
            sx={{ marginTop: "0.75rem" }}
            control={
              <Checkbox
                color="error"
                checked={isConfirmed}
                onChange={(e) => setIsConfirmed(e.target.checked)}
              />
            }
            label={
              <Typography variant="body2">
                Jag förstår att detta inte går att ångra
              </Typography>
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={close} autoFocus>
            Avbryt
          </Button>
          <Button color="error" onClick={handleDelete} disabled={!isConfirmed}>
            Ta bort filen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteBundleButton;
